import NumberOfActiveMembersByModule from "./numberOfActiveMembersByModule";
import NumberOfActiveMembersBySaga from "./redux/numberOfActiveMembersBySagas";
import NumberOfActiveMembersByReducer from "./redux/numberOfActiveMembersByReducer";

export default {
  Component: NumberOfActiveMembersByModule,
  moduleName: "numberOfActiveMembersBy",
  saga: NumberOfActiveMembersBySaga(),
  reducer: NumberOfActiveMembersByReducer
};
